import { useNavigate } from 'react-router-dom'

import { Box, Button, List, Row, Text, Title } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { useToggle } from 'usehooks-ts'

import Upgrade from 'modules/core/components/Upgrade'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { missingFeatureRequestReason } from 'modules/finance/lib/missingFeatureRequestReason'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface Props {
  hasReportOnBehalfFeature: boolean
  hideTitle?: boolean
}

const DiscoverMoreSection = ({ hasReportOnBehalfFeature, hideTitle }: Props) => {
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()

  const navigate = useNavigate()
  const [upgradeModal, showUpgradeModal] = useToggle()

  return (
    <>
      <Box flexGrow>
        <Row>
          {!hideTitle && (
            <Row.Col halfWidth>
              <Title
                variant="400"
                title={i18n.t('expenses_v2.settings.discover_more_features.title')}
                description={i18n.t('expenses_v2.settings.discover_more_features.description')}
                illustration="rocket"
              />
            </Row.Col>
          )}
          <Row.Col halfWidth>
            <List>
              <List.Item>
                <Box
                  flexDirection="row"
                  justifyContent="spaceBetween"
                  alignItems="center"
                  width="full"
                >
                  <Box gap="s12">
                    <Text.Normal weight="medium" size="300">
                      {i18n.t('expenses_v2.settings.discover_more_features.report_on_behalf.title')}
                    </Text.Normal>
                    <Text.Normal weight="normal" size="200" color="grey700">
                      {i18n.t(
                        'expenses_v2.settings.discover_more_features.report_on_behalf.description'
                      )}
                    </Text.Normal>
                    {!hasReportOnBehalfFeature && (
                      <Box width="fit-content">
                        <Upgrade.Tiny
                          title={i18n.t(
                            'expenses_v2.settings.discover_more_features.report_on_behalf.upgrade_title'
                          )}
                        />
                      </Box>
                    )}
                  </Box>
                  <Button
                    onClick={() =>
                      hasReportOnBehalfFeature
                        ? navigate(navigation.settings.permissions.fullPath())
                        : showUpgradeModal()
                    }
                    type="secondary"
                    iconName="arrow-right"
                  />
                </Box>
              </List.Item>
            </List>
          </Row.Col>
        </Row>
      </Box>
      {upgradeModal && (
        <UpsellingKit.ProductModal
          isOpen={upgradeModal}
          onClose={showUpgradeModal}
          requestSource="Expenses settings page"
          featureRequested={Features.expenses_report_on_behalf}
          moduleRequested={AvailableModules.expenses}
          requestReason={missingFeatureRequestReason(company)}
          pageSource="expenses_settings_discover_more"
        />
      )}
    </>
  )
}

export default DiscoverMoreSection
